module.exports = __webpack_public_path__ + "img/setting.a7e3fdc5.svg";